module.exports = __webpack_public_path__ + "static/media/calendary.cf518e83.svg";